import { makeActionCreator } from '../../../utilities'
import { TimesConstants } from './times.constants'

export const setOnsetTime = makeActionCreator(TimesConstants.SET_ONSET_TIME, 'time')
export const setReceivedTime = makeActionCreator(TimesConstants.SET_RECEIVED_TIME, 'time')
export const setDispatchNotifiedTime = makeActionCreator(TimesConstants.SET_DISPATCH_NOTIFIED_TIME, 'time')
export const setStandbyTime = makeActionCreator(TimesConstants.SET_STANDBY_TIME, 'time')
export const setDispatchedTime = makeActionCreator(TimesConstants.SET_DISPATCHED_TIME, 'time')
export const setAcknowledgedTime = makeActionCreator(TimesConstants.SET_ACKNOWLEDGED_TIME, 'time')
export const setEnRouteTime = makeActionCreator(TimesConstants.SET_EN_ROUTE_TIME, 'time')

export const setOnsetDate = makeActionCreator(TimesConstants.SET_ONSET_DATE, 'date')
export const setReceivedDate = makeActionCreator(TimesConstants.SET_RECEIVED_DATE, 'date')
export const setDispatchNotifiedDate = makeActionCreator(TimesConstants.SET_DISPATCH_NOTIFIED_DATE, 'date')
export const setStandbyDate = makeActionCreator(TimesConstants.SET_STANDBY_DATE, 'date')
export const setDispatchedDate = makeActionCreator(TimesConstants.SET_DISPATCHED_DATE, 'date')
export const setAcknowledgedDate = makeActionCreator(TimesConstants.SET_ACKNOWLEDGED_DATE, 'date')
export const setEnRouteDate = makeActionCreator(TimesConstants.SET_EN_ROUTE_DATE, 'date')
export const setStagingTime = makeActionCreator(TimesConstants.SET_STAGING_TIME, 'time')
export const setOnSceneTime = makeActionCreator(TimesConstants.SET_ON_SCENE_TIME, 'time')
export const setAtPatientTime = makeActionCreator(TimesConstants.SET_AT_PATIENT_TIME, 'time')
export const setTransferCareEMSTime = makeActionCreator(TimesConstants.SET_TRANSFER_CARE_EMS_TIME, 'time')
export const setLeaveReferringTime = makeActionCreator(TimesConstants.SET_LEAVE_REFERRING_TIME, 'time')
export const setArriveReceivingTime = makeActionCreator(TimesConstants.SET_ARRIVE_RECEIVING_TIME, 'time')
export const setTransferCareDestinationTime = makeActionCreator(
  TimesConstants.SET_TRANSFER_CARE_DESTINATION_TIME,
  'time'
)
export const setAvailableTime = makeActionCreator(TimesConstants.SET_AVAILABLE_TIME, 'time')
export const setCallCompletedTime = makeActionCreator(TimesConstants.SET_CALL_COMPLETED_TIME, 'time')
export const setInQuartersTime = makeActionCreator(TimesConstants.SET_IN_QUARTERS_TIME, 'time')
export const setCancelledTime = makeActionCreator(TimesConstants.SET_CANCELLED_TIME, 'time')
export const setFirstResponderTime = makeActionCreator(TimesConstants.SET_FIRST_RESPONDER_TIME, 'time')

export const setStagingDate = makeActionCreator(TimesConstants.SET_STAGING_DATE, 'date')
export const setOnSceneDate = makeActionCreator(TimesConstants.SET_ON_SCENE_DATE, 'date')
export const setAtPatientDate = makeActionCreator(TimesConstants.SET_AT_PATIENT_DATE, 'date')
export const setTransferCareEMSDate = makeActionCreator(TimesConstants.SET_TRANSFER_CARE_EMS_DATE, 'date')
export const setLeaveReferringDate = makeActionCreator(TimesConstants.SET_LEAVE_REFERRING_DATE, 'date')
export const setArriveReceivingDate = makeActionCreator(TimesConstants.SET_ARRIVE_RECEIVING_DATE, 'date')
export const setTransferCareDestinationDate = makeActionCreator(
  TimesConstants.SET_TRANSFER_CARE_DESTINATION_DATE,
  'date'
)
export const setAvailableDate = makeActionCreator(TimesConstants.SET_AVAILABLE_DATE, 'date')
export const setCallCompletedDate = makeActionCreator(TimesConstants.SET_CALL_COMPLETED_DATE, 'date')
export const setInQuartersDate = makeActionCreator(TimesConstants.SET_IN_QUARTERS_DATE, 'date')
export const setCancelledDate = makeActionCreator(TimesConstants.SET_CANCELLED_DATE, 'date')
export const setFirstResponderDate = makeActionCreator(TimesConstants.SET_FIRST_RESPONDER_DATE, 'date')
export const addOnsetCurrentDateTime = makeActionCreator(TimesConstants.ADD_ONSET_CURRENT_DATETIME, 'date', 'time')
export const addReceivedCurrentDateTime = makeActionCreator(
  TimesConstants.ADD_RECEIVED_CURRENT_DATETIME,
  'date',
  'time'
)
export const addDispatchNotifiedCurrentDateTime = makeActionCreator(
  TimesConstants.ADD_DISPATCH_NOTIFIED_CURRENT_DATETIME,
  'date',
  'time'
)
export const addStandbyCurrentDateTime = makeActionCreator(TimesConstants.ADD_STANDBY_CURRENT_DATETIME, 'date', 'time')
export const addDispatchedCurrentDateTime = makeActionCreator(
  TimesConstants.ADD_DISPATCHED_CURRENT_DATETIME,
  'date',
  'time'
)
export const addAcknowledgedCurrentDateTime = makeActionCreator(
  TimesConstants.ADD_ACKNOWLEDGED_CURRENT_DATETIME,
  'date',
  'time'
)
export const addEnRouteCurrentDateTime = makeActionCreator(TimesConstants.ADD_EN_ROUTE_CURRENT_DATETIME, 'date', 'time')
export const addFirstResponderDateTime = makeActionCreator(TimesConstants.ADD_FIRST_RESPONDER_DATETIME, 'date', 'time')
export const setSaveTimesResponse = makeActionCreator(TimesConstants.SAVE_TIMES_RESPONSE, 'response')
export const resetTimesState = makeActionCreator(TimesConstants.RESET_TIMES_STATE)
export const getTimes = makeActionCreator(TimesConstants.GET_TIMES)
export const setTimes = makeActionCreator(TimesConstants.SET_TIMES, 'times')
export const reRunTimesValidation = makeActionCreator(TimesConstants.RE_RUN_TIMES_VALIDATIONS)
export const setOnsetDateTimePNNV = makeActionCreator(TimesConstants.SET_ONSET_DATE_TIME_PNNV, 'onsetDateTimePNNV')
export const setReceivedDateTimePNNV = makeActionCreator(
  TimesConstants.SET_RECEIVED_DATE_TIME_PNNV,
  'receivedDateTimePNNV'
)
export const setEnRouteDateTimePNNV = makeActionCreator(
  TimesConstants.SET_EN_ROUTE_DATE_TIME_PNNV,
  'enRouteDateTimePNNV'
)
export const setOnSceneDateTimePNNV = makeActionCreator(
  TimesConstants.SET_ON_SCENE_DATE_TIME_PNNV,
  'onSceneDateTimePNNV'
)
export const setAtPatientDateTimePNNV = makeActionCreator(
  TimesConstants.SET_AT_PATIENT_DATE_TIME_PNNV,
  'atPatientDateTimePNNV'
)
export const setTransferCareEMSDateTimePNNV = makeActionCreator(
  TimesConstants.SET_TRANSFER_CARE_EMS_DATE_TIME_PNNV,
  'transferCareEMSDateTimePNNV'
)
export const setLeaveReferringDateTimePNNV = makeActionCreator(
  TimesConstants.SET_LEAVE_REFERRING_DATE_TIME_PNNV,
  'leaveReferringDateTimePNNV'
)
export const setArriveReceivingDateTimePNNV = makeActionCreator(
  TimesConstants.SET_ARRIVE_RECEIVING_DATE_TIME_PNNV,
  'arriveReceivingDateTimePNNV'
)
export const setTransferCareDestinationDateTimePNNV = makeActionCreator(
  TimesConstants.SET_TRANSFER_CARE_DESTINATION_DATE_TIME_PNNV,
  'transferCareDestinationDateTimePNNV'
)
export const setLeavePatientTime = makeActionCreator(TimesConstants.SET_LEAVE_PATIENT_TIME, 'time')
export const setLeavePatientDate = makeActionCreator(TimesConstants.SET_LEAVE_PATIENT_DATE, 'date')
export const addLeavePatientCurrentDateTime = makeActionCreator(
  TimesConstants.ADD_LEAVE_PATIENT_CURRENT_DATETIME,
  'date',
  'time'
)

export const setDescentTime = makeActionCreator(TimesConstants.SET_DESCENT_TIME, 'time')
export const setDescentDate = makeActionCreator(TimesConstants.SET_DESCENT_DATE, 'date')
export const addDescentCurrentDateTime = makeActionCreator(TimesConstants.ADD_DESCENT_CURRENT_DATETIME, 'date', 'time')
export const setAtLandingTime = makeActionCreator(TimesConstants.SET_AT_LANDING_TIME, 'time')
export const setAtLandingDate = makeActionCreator(TimesConstants.SET_AT_LANDING_DATE, 'date')
export const addAtLandingCurrentDateTime = makeActionCreator(
  TimesConstants.ADD_AT_LANDING_CURRENT_DATETIME,
  'date',
  'time'
)

export const setCustom1Datetime = makeActionCreator(TimesConstants.SET_CUSTOM_1_DATETIME, 'date', 'time')
export const setCustom1Date = makeActionCreator(TimesConstants.SET_CUSTOM_1_DATE, 'date')
export const setCustom1Time = makeActionCreator(TimesConstants.SET_CUSTOM_1_TIME, 'time')
export const setCustom2DateTime = makeActionCreator(TimesConstants.SET_CUSTOM_2_DATETIME, 'date', 'time')
export const setCustom2Date = makeActionCreator(TimesConstants.SET_CUSTOM_2_DATE, 'date')
export const setCustom2Time = makeActionCreator(TimesConstants.SET_CUSTOM_2_TIME, 'time')
export const setCustom3DateTime = makeActionCreator(TimesConstants.SET_CUSTOM_3_DATETIME, 'date', 'time')
export const setCustom3Date = makeActionCreator(TimesConstants.SET_CUSTOM_3_DATE, 'date')
export const setCustom3Time = makeActionCreator(TimesConstants.SET_CUSTOM_3_TIME, 'time')
export const setCustom4DateTime = makeActionCreator(TimesConstants.SET_CUSTOM_4_DATETIME, 'date', 'time')
export const setCustom4Date = makeActionCreator(TimesConstants.SET_CUSTOM_4_DATE, 'date')
export const setCustom4Time = makeActionCreator(TimesConstants.SET_CUSTOM_4_TIME, 'time')
